
function DestroyAllAddToCartPopUps() {
    $(".ui-tooltip-stuller-addtocartpopup").each(function () {
        $(this).qtip("destroy");
    });
}

$(document).ready(function () {
    window.createAddedToCartGrowl = function (data, isSerialized, isError, result, cartUrlWithReferrer, contentUrl) {
        
        DestroyAllAddToCartPopUps();

        var isSuccessfulAdd = false;
        var itemId = 0;
        var itemName = "";
        var qty = 0;
        
        var serialNumber = null;
        var matchedSetAdded = false;
        var matchedSetId = 0;

        var metalQty = 0;
        var metalLength = 0;
        var metalLengthUOM = "";
        var metalWidth = 0;
        var metalWidthUOM = "";

        var isConfiguration = false;

        if (!isError) {
            isSuccessfulAdd = true;
        }

        for (var i = 0; i < data.length; i++) {

            if (data[i]["name"] == "CartItemViewModel.ItemName") {
                itemName = data[i]["value"];
            }
            if (!isError) {
                if (data[i]["name"] == "CartItemViewModel.Quantity") {
                    qty = data[i]["value"];
                }
                if (data[i]["name"] == "CartItemViewModel.AddEntireSet") {
                    matchedSetAdded = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.Quantity") {
                    metalQty = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.Length") {
                    metalLength = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.LengthUOM") {
                    metalLengthUOM = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.Width") {
                    metalWidth = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.WidthUOM") {
                    metalWidthUOM = data[i]["value"];
                }
                if (data[i]["name"] == "ConfiguredCartItem.ConfigId") {
                    isConfiguration = true;
                }
            }
            if (isSerialized) {
                if (data[i]["name"] == "CartItemViewModel.ID") {
                    serialNumber = data[i]["value"];
                }
                if (!isError) {
                    if (data[i]["name"] == "CartItemViewModel.AddEntireSet") {
                        matchedSetAdded = data[i]["value"];
                    }
                    if (data[i]["name"] == "CartItemViewModel.MatchedSetId") {
                        matchedSetId = data[i]["value"];
                    }
                }
            } else {
                if (data[i]["name"] == "CartItemViewModel.ID") {
                    itemId = data[i]["value"];
                }
            }
        }
        
        $(".hidden-xs .shoppingCartInHeader").qtip({
            content: {
                text: function (event, api) {
                    $.ajax({
                        url: contentUrl,
                        data: {
                            isSuccessfulAdd: isSuccessfulAdd,
                            errorText: result.message,
                            makeNarrow: $(".checkoutLI").length <= 0,
                            itemId: itemId,
                            serialNumber: serialNumber,
                            quantity: qty,
                            metalQty: metalQty,
                            metalLength: metalLength,
                            metalLengthUOM: metalLengthUOM,
                            metalWidth: metalWidth,
                            metalWidthUOM: metalWidthUOM,
                            isOutOfStock: result.showOutOfStockMessage == true,
                            isConfiguration: isConfiguration,
                            matchedSetId: matchedSetId
                        }
                    }).done(function(html) {
                        api.set('content.text', html);
                    });

                    return '<img src="https://assets.stullercloud.com/web/static/i/animations/loading/bar.gif" alt="Loading..." />';
                },
                title: {
                    text: isSuccessfulAdd ? "You've Just Added" : "There was a Problem",
                    button: true
                }
            },
            position: {
                my: 'top right',
                at: 'bottom right',
                viewport: $(window),
                adjust: {
                    method: 'none shift',
                    y: 5
                },
                effect: false
            },
            show: {
                target: $(".shoppingCartInHeader"),
                ready: true,
                effect: function () {
                    $(this).slideDown(1000);
                }
            },
            style: {
                tip: false,
                classes: 'ui-tooltip-stuller-addtocartpopup ui-tooltip-shadow ui-tooltip-rounded addtocartheaderflyout',
                //width: $(".shoppingCartLI").width() + $(".checkoutLI").width() + 17
            },
            hide: {
                inactive: 5000,
                effect: function (api) {
                    $(this).slideUp(1000, function () {
                        api.destroy();
                    });
                }
            }
        }).removeData('qtip');
    };
    
    window.createGrowl = function (persistent, data, isError, result, cartUrlWithReferrer) {
        // Use the last visible jGrowl qtip as our positioning target

        //    var target1 = $('.ajax-add-button');
        //    var target2 = $('.qtip.jgrowl:visible:last');
        var target = $('.qtip.jgrowl:visible:last');

        var itemName = "";
        var qty = 0;

        var metalQty = 0;
        var metalLength = 0;
        var metalLengthUOM = "";
        var metalWidth = 0;
        var metalWidthUOM = "";

        var titleText = "";
        var displayText = "";
        var cssStyle = "";

        var matchedSetAdded = false;

        if (!isError) {
            titleText = "Successfully Added to Cart!";

            //show in growl if product is out of stock
            var outOfStockMessage = "<div class=\"smallYellowBorder lightYellowBackground\"><div class=\"leftMarginLarge rightMarginLarge center bold\"><span class=\"yellow-ui-icon-set ui-icon ui-icon-alert floatLeft\"></span>This item is out of stock and will be backordered.</div></div><br\>";

            if(result.showOutOfStockMessage == true)
                displayText = outOfStockMessage;

            for (var i = 0; i < data.length; i++) {
                if (data[i]["name"] == "CartItemViewModel.ItemName") {
                    itemName = data[i]["value"];
                }
                if (data[i]["name"] == "CartItemViewModel.Quantity") {
                    qty = data[i]["value"];
                }
                if (data[i]["name"] == "CartItemViewModel.AddEntireSet") {
                    matchedSetAdded = data[i]["value"];
                }
            }

            for (var i = 0; i < data.length; i++) {
                if (data[i]["name"] == "MetalCartItemViewModel.Quantity") {
                    metalQty = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.Length") {
                    metalLength = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.LengthUOM") {
                    metalLengthUOM = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.Width") {
                    metalWidth = data[i]["value"];
                }
                if (data[i]["name"] == "MetalCartItemViewModel.WidthUOM") {
                    metalWidthUOM = data[i]["value"];
                }
            }

            //need something here to notify out of stock piece has been added to cart.
            if (metalQty == 0) {
                displayText += itemName + ' (qty: ' + qty + ')';
                if (matchedSetAdded) {
                    displayText += " and other items in its set have";
                } else {
                    displayText += ' has';
                }
                displayText += ' been added to your cart. <br /><a href=' + cartUrlWithReferrer + '>View your cart.</a>';
            } else {
                displayText = itemName + ' (' + metalQty + ' pieces of ' + metalLength + ' ' + metalLengthUOM;
                if (metalWidth > 0) {
                    displayText += ' x ' + metalWidth + ' ' + metalWidthUOM;
                }
                displayText += ') has been added to your cart. <br /><a href=\'/cart\'>View your cart.</a>';
            }

            cssStyle = 'jgrowl ui-tooltip-stuller-green ui-tooltip-shadow ui-tooltip-rounded';
        } else {
            titleText = "Error Adding to Cart!";
            displayText = result.message;
            cssStyle = 'jgrowl ui-tooltip-stuller-red ui-tooltip-shadow ui-tooltip-rounded';
        }

        createQtip(titleText, displayText, target, persistent, cssStyle);
    };

    window.createGrowlNoData = function (persistent, title, message, isError, isBenchJeweler) {
        // Use the last visible jGrowl qtip as our positioning target

        //    var target1 = $('.ajax-add-button');
        //    var target2 = $('.qtip.jgrowl:visible:last');
        var target = $('.qtip.jgrowl:visible:last');

        titleText = title;
        displayText = message;

        if (!isError) {
            if (isBenchJeweler) {
                cssStyle = 'jgrowl ui-tooltip-stuller-bench ui-tooltip-shadow ui-tooltip-rounded';
            } else {
                cssStyle = 'jgrowl ui-tooltip-stuller-green ui-tooltip-shadow ui-tooltip-rounded';
            }
        } else {
            cssStyle = 'jgrowl ui-tooltip-stuller-red ui-tooltip-shadow ui-tooltip-rounded';
        }

        createQtip(titleText, displayText, target, persistent, cssStyle);
    };

    function createQtip(titleText, displayText, target, persistent, cssStyle) {
        // Create your jGrowl qTip...
        $(document.body).qtip({
            content: {
                text: displayText,
                title: {
                    text: titleText,
                    button: true
                }
            },
            position: {
                my: 'top center', // Not really important...
                at: (target.length ? 'bottom' : 'top') + ' center', // If target is window use 'top right' instead of 'bottom right'
                target: target.length ? target : $(window), // Use our target declared above
                adjust: { y: 5 }, // Add some vertical spacing
                viewport: $(window)
                //                        my: 'top center', // Not really important...
                //                        at: (target1.length ? 'bottom' : 'top') + ' center', // If target is window use 'top right' instead of 'bottom right'
                //                        target: target2.length ? target2 : (target1.length ? target1 : $(window)), // Use our target declared above
                //                        adjust: { y: 5 }, // Add some vertical spacing
                //                        viewport: $(window)
            },
            show: {
                event: false, // Don't show it on a regular event
                ready: true, // Show it when ready (rendered)
                effect: function () { $(this).stop(0, 1).fadeIn(200); }, // Matches the hide effect

                // Custom option for use with the .get()/.set() API, awesome!
                persistent: persistent
            },
            hide: {
                event: false, // Don't hide it on a regular event
                effect: function (api) {
                    // Do a regular fadeOut, but add some spice!
                    $(this).stop(0, 1).fadeOut(200).queue(function () {
                        // Destroy this tooltip after fading out
                        api.destroy();

                        // Update positions
                        updateGrowls();
                    })
                }
            },
            style: {
                classes: cssStyle, // Some nice visual classes
                tip: false // No tips for this one (optional ofcourse)
            },
            events: {
                render: function (event, api) {
                    // Trigger the timer (below) on render
                    timer.call(api.elements.tooltip, event);
                }
            }
        })
        .removeData('qtip');
    }

    // Make it a window property see we can call it outside via updateGrowls() at any point
    window.updateGrowls = function () {
        // Loop over each jGrowl qTip
        var each = $('.qtip.jgrowl:not(:animated)');
        each.each(function (i) {
            var api = $(this).data('qtip');

            // Set the target option directly to prevent reposition() from being called twice.
            api.options.position.target = !i ? $(document.body) : each.eq(i - 1);
            api.set('position.at', (!i ? 'top' : 'bottom') + ' center');
        });
    };

    // Setup our timer function
    function timer(event) {
        var api = $(this).data('qtip'),
        lifespan = 5000; // 5 second lifespan

        // If persistent is set to true, don't do anything.
        if (api.get('show.persistent') === true) { return; }

        // Otherwise, start/clear the timer depending on event type
        clearTimeout(api.timer);
        if (event.type !== 'mouseover') {
            api.timer = setTimeout(api.hide, lifespan);
        }
    }

    // Utilise delegate so we don't have to rebind for every qTip!
    $(document).delegate('.qtip.jgrowl', 'mouseover mouseout', timer);

});